import T from "@marginly/ui/components/typography";
import copy from "copy-to-clipboard";
import { useState } from "react";

import { trackReferralLinkCopyClick } from "@/util/tracking";

import * as S from "./styled";
import { createReferralUrl, createShortReferralUrl } from "./utils";

interface Props {
  referralCode: string;
}

export const ReferralLink = ({ referralCode }: Props) => {
  const [showCopied, setShowCopied] = useState(false);
  const handleCopy = () => {
    if (!referralCode) return;

    trackReferralLinkCopyClick();
    copy(createReferralUrl(referralCode));
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 3000);
  };
  return (
    <>
      <S.Notification className={showCopied ? "shown" : ""}>
        <img src="/images/copy-link.svg" alt="" />
        Invitation link copied.
      </S.Notification>
      <S.ReferralContainer>
        <S.ReferralLabel>Share link</S.ReferralLabel>
        <S.ReferralUrl>{createShortReferralUrl(referralCode)}</S.ReferralUrl>
        <S.ReferralCopyButton onClick={handleCopy} action secondary>
          Copy
        </S.ReferralCopyButton>
      </S.ReferralContainer>
    </>
  );
};
